// CSRF token 优先读 XSRF-TOKEN cookie，<meta> 只作兜底。顺序反过来会坏，而且
// 坏得很难认：
//
// 登录时 Web::SessionsController#create 调 reset_session，于是 session 里的
// _csrf_token 换了一个。而 <meta name="csrf-token"> 是 layouts/inertia.html.erb
// 渲染整页时写进 <head> 的，Inertia 的 XHR 导航（含登录后跟随 302 那一跳）只换
// 页面组件、不重新渲染 <head> —— 所以登录之后页面上那个 meta token 仍然属于
// 登录前那个已经作废的 session。带着它发写请求，Rails 回
// `ActionController::InvalidAuthenticityToken` + 422，而那条消息与「Origin 不
// 匹配」共用，看着像凭证坏了或跨域问题。硬刷新一次就好（整页重渲染 → meta 变新），
// 于是它表现得像个幽灵 bug。
//
// XSRF-TOKEN cookie 没有这个问题：Web::Internal::BaseController 的 after_action
// set_csrf_cookie 在每个响应上重写它，reset_session 之后第一个请求就是新值。
// 那个 after_action 本来就是为此存在的（Inertia 自带的 axios 也读它）。
//
// 实测（不登录也能验，CSRF 检查跑在 require_login! 之前，过了是 401）：
//   同一个 meta token，reset_session 之前 → 401 通过；之后 → 422 失败。
//
// 注意 cookie 值是 URL 编码过的（token 是 base64，含 + / =），必须解码。
export function csrfToken(): string {
  if (typeof document === 'undefined') return ''

  const fromCookie = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith('XSRF-TOKEN='))
  if (fromCookie) return decodeURIComponent(fromCookie.slice('XSRF-TOKEN='.length))

  // 兜底：整页刚加载、还没打过任何 /web/internal 端点时 cookie 尚不存在，
  // 而此刻 meta 是新鲜的。
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''
}
